import { useAdaControls } from 'Shared/hooks/useAdaControls/useAdaControls';
import { useStradaControls } from 'Shared/hooks/useStradaControls/useStradaControls';
import { useZendeskControls } from 'Shared/hooks/useZendeskControls/useZendeskControls';
import { useQaToggleFeature } from 'Shared/hooks';
import { env } from 'Shared/constants/env';

type ZendeskVariant = 'main' | 'quoteApp';

type UseHelpdeskControlsOptions = {
  zendeskVariant?: ZendeskVariant;
};

/**
 * Hook that provides unified helpdesk controls.
 * Priority: Strada (if enabled via Optimizely) > Ada > Zendesk
 */
export const useHelpdeskControls = (
  options: UseHelpdeskControlsOptions = {}
) => {
  const { zendeskVariant = 'main' } = options;

  const ada = useAdaControls();
  const strada = useStradaControls();
  const zendesk = useZendeskControls(zendeskVariant);

  const [isStradaEnabled] = useQaToggleFeature('strada_integration');

  const isUsingStrada =
    isStradaEnabled &&
    env.stradaAgentId !== '' &&
    env.stradaOrganizationId !== '';
  const isUsingAda = env.adaChatEnabled && !isUsingStrada;

  const loaded = isUsingStrada
    ? strada.loaded
    : isUsingAda
      ? ada.loaded
      : zendesk.loaded;

  const toggleOpen = isUsingStrada
    ? strada.toggleOpen
    : isUsingAda
      ? ada.toggleOpen
      : zendesk.toggleOpen;

  const isOpen = isUsingStrada
    ? strada.isOpen
    : isUsingAda
      ? ada.isOpen
      : zendesk.isOpen;

  const eventName = isUsingStrada
    ? 'aqui-strada-widget-open'
    : isUsingAda
      ? 'aqui-ada-widget-open'
      : 'aqui-zendesk-widget-open';

  return {
    loaded,
    toggleOpen,
    isOpen,
    isUsingStrada,
    isUsingAda,
    eventName,
    widgetIsMessengerVersion: zendesk.widgetIsMessengerVersion,
  };
};
